/* Scroll reveal for the Text boxes section. The markup is already complete and
   visible without JS — the hidden resting state lives behind the `data-animate`
   attribute this element sets on itself, so a failed or blocked script leaves
   every block on screen rather than blanking the section. */

class TextBoxes extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('[data-textboxes-item]'));
    if (!this.items.length) return;

    // Reduced motion still gets the section, just without the travel — nothing
    // to arm, so the resting state is never applied.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.setAttribute('data-animate', 'true');

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.setAttribute('data-textboxes-visible', 'true');
          this.observer.unobserve(entry.target);
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
    );

    this.items.forEach((item) => this.observer.observe(item));
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

if (!customElements.get('text-boxes')) {
  customElements.define('text-boxes', TextBoxes);
}
